import React from 'react'
import { cn } from '../../lib/utils'

interface IconPlusProps {
  className?: string
  strokeWidth?: number
  color?: string
}

export const IconPlus: React.FC<IconPlusProps> = ({ className, strokeWidth, color }) => {
  return (
    <svg
      className={cn('w-[16px]', className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill={color ?? '#122B4680'}
        stroke={color ?? 'transparent'}
        strokeWidth={strokeWidth}
        className="group-hover:fill-SeabiscuitMainThemeColor"
        d="M7.992 1.66a.5.5 0 00-.492.507v5.334H2.166a.5.5 0 100 1H7.5v5.333a.5.5 0 101 0V8.501h5.333a.5.5 0 100-1H8.5V2.167a.5.5 0 00-.508-.507z"
      ></path>
    </svg>
  )
}
